import { fetchQuery, graphql } from "react-relay"
import { validatePhoneNumberQuery } from "@/lib/__generated__/validatePhoneNumberQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query validatePhoneNumberQuery($phoneNumber: String!) {
    validatePhoneNumber(phoneNumber: $phoneNumber)
  }
`

const phoneNumberCheckCache = new Map<string, boolean>()

const checkPhoneNumber = (phoneNumber: string) =>
  fetchQuery<validatePhoneNumberQuery>(RelayEnvironment, query, { phoneNumber })
    .toPromise()
    .then((response) => {
      const isValid = response?.validatePhoneNumber ?? false
      phoneNumberCheckCache.set(phoneNumber, isValid)
      return isValid
    })

export const debouncedValidatePhoneNumber = () => {
  return (phoneNumber: string) => {
    const cachedResult = phoneNumberCheckCache.get(phoneNumber)
    if (cachedResult !== undefined) return cachedResult

    return new Promise<boolean>((resolve) => {
      resolve(checkPhoneNumber(phoneNumber))
    })
  }
}
